import { Injectable } from '@angular/core';
import { Logger } from '@common/logging/logger';
import { ProduktlyService } from '@services/produktly/produktly.service';
import { ISyncContext } from '../contracts/sync/sync-context';
import { ISyncElement, SyncElementResult } from '../contracts/sync/sync-element';

@Injectable()
export class ProduktlyInitializer implements ISyncElement {
  public get name(): string {
    return 'ProduktlyInitializer';
  }

  constructor(
    private _produktlyService: ProduktlyService,
    private _logger: Logger
  ) {}

  public async execute(context: ISyncContext): Promise<SyncElementResult> {
    try {
      await this._produktlyService.clearProduktlyUser();
      await this._produktlyService.init();
    } catch (error) {
      this._logger.error('[ProduktlyInitializer] execute failed', error);
    }
    return { contextId: context.id, jobDone: true };
  }
}
